export const grantAlertKinds = [
  'created',
  'opening_soon',
  'opened',
  'closing_soon',
  'closed',
  'updated',
] as const;

export type GrantAlertKind = (typeof grantAlertKinds)[number];

export const isGrantAlertKind = (value: string): value is GrantAlertKind =>
  grantAlertKinds.includes(value as GrantAlertKind);

export type GrantAlertHistoryItem = {
  alert_id: string;
  grant_id: string;
  grant_title: string;
  kind: GrantAlertKind;
  delivered_at: string;
};

export type GrantAlertHistoryResponse = {
  alerts: GrantAlertHistoryItem[];
  total: number;
  limit: number;
  offset: number;
  has_more: boolean;
};
